import { useCopy } from "../../utils/globalContext";
import type { RootState } from "../../store/rootReducer";
import {
  clearError as clearErrorStore,
  clearErrorCopyKey as clearErrorCopyKeyStore,
  clearTraceId,
} from "../../store/auth";
import type { ErrorState } from "../../store/auth";
import { useAppDispatch } from "../../store/configureStore";
import type { FC } from "react";
import { useSelector } from "react-redux";
import { ErrorCard } from "@kivra/react-components";
import { mapErrorCodeToCopyKey } from "../../@api/apiError";

export const ErrorMessage: FC = () => {
  const { errorCopyKey, errorCode, traceId } = useSelector<
    RootState,
    ErrorState
  >(getErrorState);
  const { clearErrorCopyKey, clearCode, clearTrace } = useErrorMessageActions();
  const getCopy = useCopy();
  const showError = errorCopyKey || errorCode || traceId;
  const getErrorTextAndClear = () => {
    if (errorCopyKey) {
      return {
        errorText: getCopy(...errorCopyKey),
        clear: clearErrorCopyKey,
      };
    } else if (errorCode) {
      return {
        errorText: getCopy(...mapErrorCodeToCopyKey(errorCode)),
        clear: clearCode,
      };
    } else if (traceId) {
      return {
        errorText: `${
          getCopy(
            "strong_auth_error__access_denied",
          )
        } ${traceId}`,
        clear: clearTrace,
      };
    } else {
      return {
        errorText: "",
        clear: (): null => null,
      };
    }
  };

  const { errorText } = getErrorTextAndClear();
  if (!showError) {
    return;
  }
  return <ErrorCard>{errorText}</ErrorCard>;
};

const getErrorState = (state: RootState): ErrorState => ({
  errorCopyKey: state.auth.error.errorCopyKey,
  errorCode: state.auth.error.errorCode,
  traceId: state.auth.error.traceId,
});

const useErrorMessageActions = () => {
  const dispatch = useAppDispatch();
  return {
    clearErrorCopyKey: () => dispatch(clearErrorCopyKeyStore()),
    clearCode: () => dispatch(clearErrorStore()),
    clearTrace: () => dispatch(clearTraceId()),
  };
};
